import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import Paper from "@material-ui/core/Paper";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Input from "@material-ui/core/Input";
import SendIcon from "@material-ui/icons/Send";
import Typography from "@material-ui/core/Typography";

import ChatUsers from "./ChatUsers";
import ChatRoom from "./ChatRoom";
import { compose } from "redux";
import { connect } from "react-redux";
import { getCollection } from "../../constant";
import { firestoreConnect } from "react-redux-firebase";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import RemoveIcon from "@material-ui/icons/Remove";
import Badge from "@material-ui/core/Badge";

import InputBase from "@material-ui/core/InputBase";
import { fade, makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";

const layout = {
  display: "block",
  background: "#fff",
  opacity: 0,
  height: 0,
  width: 0,
  transition: "height 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
};
const styles = (theme) => ({
  chatMain: {
    position: "fixed",
    right: 10,
    bottom: 0,
    zIndex: 100000,
  },
  layout: { ...layout },
  chatIcon: {
    position: "fixed",
    right: 10,
    bottom: 10,
  },
  layoutOpen: {
    ...layout,
    height: 500,
    width: 300,
    zIndex: 2,
    position: "relative",
    zIndex: 11,
    opacity: 1,
  },

  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: -10,
    width: "auto",
    // [theme.breakpoints.up('sm')]: {
    //   marginLeft: theme.spacing(1),
    //   width: 'auto',
    // },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "28ch",
      "&:focus": {
        width: "31ch",
      },
    },
  },
});

const defaultProps = {
  color: "secondary",
  children: <ChatBubbleIcon style={{ color: "#fff" }} />,
};

class Chats extends React.Component {
  state = {
    messages: [],
    show: false,
    chatRoom: null,
  };

  open = () => {
    const { show } = this.state;
    this.setState({ show: !show });
  };

  handleUserClick = (user) => {
    const { firestore, profile } = this.props;
    const users = [
      { id: user.id, displayName: user.displayName },
      { id: profile.id, displayName: profile.displayName },
    ];
    const userIds = [user.id, profile.id];
    const chatRoom = {
      users,
      id: getRoomId(users),
      updatedAt: new Date(),
      userIds,
    };

    firestore
      .collection(getCollection(profile, "chats"))
      .doc(chatRoom.id)
      .set(chatRoom)
      .then(
        (data) => {
          chatRoom.notifications = user.notifications;
          this.setState({ chatRoom });
        },
        (err) => {
          // debugger
        }
      );
  };

  handleClose = () => {
    const { chatRoom } = this.state;

    if (chatRoom) {
      this.setState({ chatRoom: null });
    } else {
      this.setState({ show: false });
    }
  };

  handleBack = () => {
    this.setState({ chatRoom: null });
  };

  handleMinimize = () => {
    this.setState({ show: false });
  };

  getTitle = () => {
    const { show, chatRoom } = this.state;
    const { profile } = this.props;

    if (chatRoom) {
      if (chatRoom.users.length == 2) {
        for (let i = 0; i < chatRoom.users.length; i++) {
          if (chatRoom.users[i].id !== profile.id)
            return chatRoom.users[i].displayName;
        }
      } else {
        let names = "";
        for (let i = 0; i < chatRoom.users.length; i++) {
          if (!names) names += chatRoom.users[i].displayName;
          else names += `, ${chatRoom.users[i].displayName}`;
        }

        return names;
      }

      return chatRoom.name || "Group Chat";
    } else {
      return "Chats";
    }
  };

  render() {
    const { classes, chatNotifications = [] } = this.props;
    const { chatMain, layout, chatIcon, layoutOpen } = classes;
    const { show, chatRoom } = this.state;

    // console.log("chatNotifications  : ", chatNotifications)

    return (
      <div className={chatMain}>
        <Paper>
          <div className={show ? layoutOpen : layout}>
            <AppBar position="static">
              <Toolbar>
                {!chatRoom ? null : (
                  <IconButton
                    style={{ marginLeft: -25 }}
                    onClick={this.handleBack}
                  >
                    <ArrowBackIcon style={{ color: "#fff" }} />
                  </IconButton>
                )}

                {/* {chatRoom && */}
                <Typography
                  variant="subtitle1"
                  color="inherit"
                  className={classes.grow}
                >
                  {this.getTitle()}
                </Typography>
                {/* } */}

                {chatRoom ? (
                  <IconButton
                    style={{ position: "absolute", right: 5 }}
                    onClick={this.handleMinimize}
                  >
                    <RemoveIcon style={{ color: "#fff" }} />
                  </IconButton>
                ) : (
                  <IconButton
                    style={{ position: "absolute", right: 5 }}
                    onClick={this.handleClose}
                  >
                    <CloseIcon style={{ color: "#fff" }} />
                  </IconButton>
                )}

                {/*
                  !chatRoom &&
                  <div className={classes.search}>
                    <div className={classes.searchIcon}>
                      <SearchIcon />
                    </div>
                    <InputBase
                      placeholder="Search…"
                      classes={{
                        root: classes.inputRoot,
                        input: classes.inputInput,
                      }}
                      inputProps={{ 'aria-label': 'search' }}
                    />
                  </div>
                    */}
              </Toolbar>
            </AppBar>
            {chatRoom ? (
              <ChatRoom room={chatRoom} />
            ) : (
              <ChatUsers
                chatNotifications={chatNotifications}
                userClick={this.handleUserClick}
              />
            )}
          </div>
        </Paper>
        <Fab
          className={chatIcon}
          onClick={this.open}
          color="primary"
          aria-label="edit"
        >
          <Badge
            badgeContent={chatNotifications.length}
            max={999}
            {...defaultProps}
          />
        </Fab>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.firebase.profile,
    chatNotifications:
      state.firestore.ordered[
        getCollection(state.firebase.profile, "chatNotifications")
      ],
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    console.log(
      "getCollection(props.profile, 'chatNotifications') : ",
      props && getCollection(props.profile, "chatNotifications")
    );
    if (props.profile && props.profile.id)
      return [
        {
          collection: getCollection(props.profile, "chatNotifications"),
          where: [
            ["userId", "==", props.profile.id],
            // ['roomId', '==', '2397R2436']
          ],
        },
      ];
    return [];
  })
)(withStyles(styles)(Chats));

function getRoomId(users) {
  let roomId = "";
  const uIdArr = [];

  users.forEach(({ id }) => {
    let uId = 0;
    for (let i = 0; i < id.length; i++) {
      uId += id[i].charCodeAt();
    }
    uIdArr.push(uId);
  });

  uIdArr.sort();

  return uIdArr.join("R");
}
